import PropTypes from "prop-types";
import React, { Component } from "react";
import {
  Button,
  Container,
  Divider,
  Grid,
  Header,
  Icon,
  Image,
  List,
  Menu,
  Segment,
  Sidebar,
  Visibility
} from "semantic-ui-react";
import { useMediaQuery } from "react-responsive"; // <-- new import
import Crossword from "./Crossword";
import Countdown from "./Timer";

// Breakpoints
const breakpoints = {
  mobileMax: 767,
  tabletMin: 768,
  desktopMin: 992
};

// Hook to check screen size
const useIsDesktop = () => useMediaQuery({ minWidth: breakpoints.desktopMin });
const useIsTablet = () =>
  useMediaQuery({ minWidth: breakpoints.tabletMin, maxWidth: breakpoints.desktopMin - 1 });
const useIsMobile = () => useMediaQuery({ maxWidth: breakpoints.mobileMax });

// --------------------- DESKTOP CONTAINER ---------------------
// --------------------- DESKTOP CONTAINER ---------------------
const DesktopContainer = ({ children }) => {
  const isDesktop = useMediaQuery({ minWidth: breakpoints.tabletMin });

  if (!isDesktop) return null;

  return (
    <Visibility once={false}>
      {children}
    </Visibility>
  );
};

DesktopContainer.propTypes = {
  children: PropTypes.node
};

// --------------------- MOBILE CONTAINER ---------------------
const MobileContainer = ({ children }) => {
  const isMobile = useMediaQuery({ maxWidth: breakpoints.mobileMax });

  if (!isMobile) return null;

  return <Sidebar.Pushable style={{ overflowX: "hidden" }}>{children}</Sidebar.Pushable>;
};

MobileContainer.propTypes = {
  children: PropTypes.node
};

// --------------------- RESPONSIVE CONTAINER ---------------------
const ResponsiveContainer = ({ children }) => (
  <div>
    <DesktopContainer>{children}</DesktopContainer>
    <MobileContainer>{children}</MobileContainer>
  </div>
);

ResponsiveContainer.propTypes = {
  children: PropTypes.node
};

// --------------------- HOMEPAGE LAYOUT ---------------------
const HomepageLayout = () => {
  const isTablet = useIsTablet();
  const isDesktop = useIsDesktop();
  const isMobile = useIsMobile();

  return (
    <ResponsiveContainer>
      <Countdown />
      <Segment style={{ padding: "5em 0em" }} vertical>
        <Grid container stackable verticalAlign="middle" textAlign="center">
          <Header as="h1" style={{ fontSize: "3rem", margin: "1rem 0" }}>
            Cryptick
          </Header>
          <Grid.Row>
            <div style={{
              maxWidth: "100%",
              overflowX: "auto",
              WebkitOverflowScrolling: "touch"
            }}>
              <Crossword />
            </div>
          </Grid.Row>
        </Grid>
      </Segment>
    </ResponsiveContainer>
  );
};

export default HomepageLayout;